(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/constants.js');
"use strict";



const ROUTES = {
  LOBBY: '/',
  FAVORITES: '/favoriter',
  FAVORITES_INFO: '/favoriter/info/:gameId',
  CATEGORY: '/kategori/:categoryId',
  CATEGORY_INFO: '/kategori/:categoryId/info/:gameId',
  INFO: '/info/:gameId',
  PLAY: '/spela/:gameId',
  DEMO_PLAY: '/provspela/:gameId',
  BET_DETAIL: '/mina-spel/:wagerId',
  ALL_GAMES: '/alla-spel',
  ALL_GAMES_INFO: '/alla-spel/info/:gameId'
};
const sortByPublishedDate = games => [...games].sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate));
const formatNumber = number => parseInt(number.replace(/\s+/g, ''), 10);
const DEFAULT = 'default';
const WINNINGS_DESC = 'winnings-desc';
const PRICE_ASC = 'price-asc';
const PUBLISHED = 'published';
const ALPHABETICAL = 'alphabetical';
const sortOptions = [{
  id: DEFAULT,
  icon: 'new-games',
  label: 'Rekommenderade',
  sortFn: games => [...games]
}, {
  id: WINNINGS_DESC,
  icon: 'loss-limit',
  iconClasses: 'tickets-einstant-icon-scale-x-reverse',
  label: 'Vinstnivå: Hög - låg',
  sortFn: games => sortByPublishedDate(games).sort((a, b) => formatNumber(b.maxWin) - formatNumber(a.maxWin))
}, {
  id: PRICE_ASC,
  icon: 'loss-limit',
  label: 'Pris: Låg - hög',
  sortFn: games => sortByPublishedDate(games).sort((a, b) => {
    const [minPriceA, maxPriceA] = [formatNumber(a.minPrice), formatNumber(a.maxPrice || a.minPrice)];
    const [minPriceB, maxPriceB] = [formatNumber(b.minPrice), formatNumber(b.maxPrice || b.minPrice)];
    return minPriceA + maxPriceA - (minPriceB + maxPriceB);
  })
}, {
  id: PUBLISHED,
  icon: 'new-games',
  label: 'Nyhet',
  sortFn: sortByPublishedDate
}, {
  id: ALPHABETICAL,
  icon: 'alphabetic',
  label: 'Bokstavsordning',
  sortFn: games => sortByPublishedDate(games).sort((a, b) => a.name.localeCompare(b.name))
}];
const getSortOptionById = id => sortOptions.find(o => o.id === id) || sortOptions.find(o => o.id === 'default');
setGlobal('svs.eInstant.constants', {
  ROUTES,
  sortOptions,
  getSortOptionById,
  sortIds: {
    DEFAULT,
    WINNINGS_DESC,
    PRICE_ASC,
    PUBLISHED,
    ALPHABETICAL
  }
});

 })(window);